import { doGetQuery, doPostQuery, LS_ACCESS_TOKEN_KEY } from './utils';

export const apiLogin = async (
  login: string,
  password: string
): Promise<void> =>
  doPostQuery<{ accessToken?: string }>('auth/login', null, {
    username: login,
    password,
  }).then(applyAccessToken);

export const apiLoginAs = async (userUid: string): Promise<void> =>
  doPostQuery<{ accessToken?: string }>(`auth/login/${userUid}`).then(
    applyAccessToken
  );

export const apiGetMe = () =>
  doGetQuery<{ user: TUser | null }>(`auth/me`).then(({ user }) => user);

const applyAccessToken = ({ accessToken }: { accessToken?: string }) => {
  if (accessToken) {
    // accessToken is given if env.JWT_STORAGE === 'localStorage'
    localStorage.setItem(LS_ACCESS_TOKEN_KEY, accessToken);
  }
  // otherwise it's in the httpOnly cookie.
};

export const apiLogout = async (): Promise<void> =>
  doPostQuery('auth/logout').then(() => {
    localStorage.removeItem(LS_ACCESS_TOKEN_KEY);
  });
